import { LoadChangedAction } from '../../../../enums/load-changed-action.enum';
import { ILoadHistoryEventResponse } from '../../../../interfaces/ILoadHistoryResponse';
import LanguageContext from '../../../../../../../app/contexts/language';
import i18n from '../../../../../../../lib/i18n';
import LoadHistoryUtils from '../../utils/load-history-drawer.utils';

function HistoryItemConfirmed({
    history,
}: Readonly<{
    history: ILoadHistoryEventResponse;
}>) {
    const userLanguage = LanguageContext.useLanguage();
    const carriers = history.metadata?.carriers ?? [];
    const carrier = carriers.length > 0 ? carriers[0] : undefined;
    const fallbackCarrierLabel = i18n.t(
        'LoadHistory.CarrierWithoutRegisterOnSulaHub',
    );

    const getCarrierLabel = (withCode = false) => {
        if (!carrier) {
            return fallbackCarrierLabel;
        }

        return LoadHistoryUtils.getCarrierLabel(carrier, withCode);
    };

    const getWinnerDescriptionByPoolConfirmation = () => {
        if (!carrier) {
            return (
                <div className="load-history-event-confirmed-reason">
                    <span>{fallbackCarrierLabel}</span>
                </div>
            );
        }

        const currency = LoadHistoryUtils.getCurrency(
            carrier,
            userLanguage.language,
        );
        const rank = carrier.rank ? ` - Rank ${carrier.rank}` : '';
        const carrierName = LoadHistoryUtils.getCarrierLabel(carrier);
        const vehicleDescription = carrier.vehicleDescription?.trim();
        const carrierWithVehicle = vehicleDescription
            ? `${carrierName} | ${vehicleDescription}`
            : carrierName;

        return (
            <div className="load-history-event-confirmed-reason">
                <span>
                    {carrierWithVehicle} - {currency}
                    {rank}
                </span>
            </div>
        );
    };

    const getWinnerDescriptionByApp = () => {
        return (
            <div className="load-history-event-confirmed-reason">
                <span>{i18n.t('LoadHistory.LoadConfirmed')}</span>
                <span>{getCarrierLabel(true)}</span>
            </div>
        );
    };

    const getWinnerDescriptionByTenderAccepted = () => {
        if (!carrier) {
            return (
                <div className="load-history-event-confirmed-reason">
                    <span>{i18n.t('LoadHistory.LoadConfirmedByTms')}</span>
                    <span>{getCarrierLabel(true)}</span>
                </div>
            );
        }

        const currency = LoadHistoryUtils.getCurrency(
            carrier,
            userLanguage.language,
        );
        const carrierLabel = LoadHistoryUtils.getCarrierLabel(carrier, true);

        return (
            <div className="load-history-event-confirmed-reason">
                <span>{i18n.t('LoadHistory.LoadConfirmedByTms')}</span>
                <span>
                    {carrierLabel} - {currency}
                </span>
            </div>
        );
    };

    const getWinnerDescription = () => {
        if (history.eventType === LoadChangedAction.ConfirmationPool) {
            return getWinnerDescriptionByPoolConfirmation();
        }
        if (history.eventType === LoadChangedAction.TenderAccepted) {
            return getWinnerDescriptionByTenderAccepted();
        }
        return getWinnerDescriptionByApp();
    };

    return (
        <div
            key={history.eventDate.toString()}
            className="load-history-event-container load-history-line"
            data-testid="load-history-event"
        >
            <div className="load-history-section-title">
                <h4 className="load-history-event-type">
                    {LoadHistoryUtils.getEventLabel(history)}
                </h4>
            </div>
            <span>{LoadHistoryUtils.getDateTimeLabel(history.eventDate)}</span>
            {getWinnerDescription()}
        </div>
    );
}

export default HistoryItemConfirmed;
